import React from 'react';
import { Box, Container, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import withWebsiteContent from '../../../common/withWebsiteContent';

/**
 * RODO privacy clause — content from website-content defaultProps.
 *
 * Expected defaultProps shape (rodo-clause/metadata.json):
 * {
 *   "title": "...",
 *   "intro": "...",
 *   "points": [
 *     { "text": "...", "subPoints": ["a. ...", "b. ..."] }
 *   ]
 * }
 */
export const RodoClausePure = ({
  title = '',
  intro = '',
  points = [],
  images = [],
}) => {
  if (!title && !intro && points.length === 0) return null;

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="md">
        {title && (
          <Typography
            variant="h4"
            component="h1"
            sx={{ textAlign: 'center', mb: 4, fontWeight: 600 }}
          >
            {title}
          </Typography>
        )}
        <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 }, borderRadius: 2, borderColor: 'divider' }}>
          {intro && (
            <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-line' }}>
              {intro}
            </Typography>
          )}

          {points.length > 0 && (
            <List dense disablePadding component="ol" sx={{ pl: 2, listStyle: 'decimal' }}>
              {points.map((point, index) => (
                <ListItem
                  key={index}
                  disableGutters
                  component="li"
                  sx={{ display: 'list-item', py: 1, alignItems: 'flex-start' }}
                >
                  <ListItemText
                    primary={point.text}
                    secondary={
                      Array.isArray(point.subPoints) && point.subPoints.length > 0 ? (
                        <List dense disablePadding component="ul" sx={{ pl: 2, mt: 1, listStyle: 'lower-alpha' }}>
                          {point.subPoints.map((subPoint, subIndex) => (
                            <ListItem
                              key={subIndex}
                              disableGutters
                              component="li"
                              sx={{ display: 'list-item', py: 0.25 }}
                            >
                              <ListItemText
                                primary={subPoint}
                                primaryTypographyProps={{ variant: 'body2' }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      ) : null
                    }
                    primaryTypographyProps={{
                      variant: 'body1',
                      sx: { whiteSpace: 'pre-line' },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

const RodoClause = withWebsiteContent(RodoClausePure);
RodoClause.displayName = 'RodoClause';

export default RodoClause;
